import React, { useEffect } from "react";
import TermsContent from "../TermsContent";
import MiniHero from "./../MiniHero";

function TermsAndConditions({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="Terms & Conditions"
        className="fs-48 text-dark mb-5"
      />
      <div className="container py-5">
        <TermsContent />
      </div>
    </>
  );
}

export default TermsAndConditions;
